.message {
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
}

.list {
  margin: 0;
  padding-left: 1.25rem;
}
